export const API_BASE_URL = "/api/v1";
export const API_LOGIN = `${API_BASE_URL}/tokens`;

export const API_ADMIN_LOGIN = `${API_BASE_URL}/admin/login`;
export const API_ADMIN_LOGOUT = `${API_BASE_URL}/admin/logout`;

export const API_ADMIN_CONFIRM_CODE = `${API_BASE_URL}/admin/confirm_code`;
export const API_ADMIN_RESEND_CONFIRM_CODE = `${API_BASE_URL}/admin/resend_code`;

export const API_CREATE_USER = `${API_BASE_URL}/users`;
export const API_UPDATE_USER = `${API_BASE_URL}/users/`;
export const API_SHOW_USER = `${API_BASE_URL}/users/`;

export const API_FORGOT_PASSWORD = `${API_BASE_URL}/forgot_passwords`;
export const API_NEW_PASSWORD = `${API_BASE_URL}/update_passwords/1`;

export const API_WEBINARS = `${API_BASE_URL}/webinars`;
export const API_UPCOMING_WEBINARS = `${API_BASE_URL}/upcoming_webinars`;
export const API_PREVIOUS_WEBINARS = `${API_BASE_URL}/previous_webinars`;
export const API_CURRENT_WEBINARS = `${API_BASE_URL}/current_webinars`;
export const API_LANDING_WEBINARS = `${API_BASE_URL}/landing_webinars`;

export const API_LIVE_WEBINARS = `${API_BASE_URL}/cpd_live`;
export const API_RECORDED_WEBINARS = `${API_BASE_URL}/cpd_recorded`;
export const API_USERS_WEBINARS = `${API_BASE_URL}/current_webinars`;
export const API_WEBINARS_USERS = `${API_BASE_URL}/admin/webinar_users`;
export const API_WEBINARS_USERS_NEWSLETTER = `${API_BASE_URL}/admin/newsletter_users`;
export const API_WEBINARS_VIEWED_USERS = `${API_BASE_URL}/admin/webinar_users/viewed_export`;
export const API_CERTIFICATES_USERS = `${API_BASE_URL}/admin/sertificates_users`;
export const API_ADMIN_CERTIFICATES = `${API_BASE_URL}/admin/sertificates`;

export const API_LOAD_USER_WEBINARS_YEARS = `${API_BASE_URL}/webinar/years`;

export const API_SUBSCRIPTIONS = `${API_BASE_URL}/subscriptions`;

export const API_VIMEO_VIDEO_DATA = "https://vimeo.com/api/v2/video/";

export const API_RESULTS = `${API_BASE_URL}/results`;

export const API_CERTIFICATES = `${API_BASE_URL}/pdf_outputs`;

export const API_SYSTEM_FEEDBACKS = `${API_BASE_URL}/system_feedbacks`;
export const ADMIN_API_SYSTEM_FEEDBACKS = `${API_BASE_URL}/admin/system_feedbacks`;

export const API_HOSPITALS = `${API_BASE_URL}/hospitals`;
export const API_COUNTIES = `${API_BASE_URL}/counties`;
export const API_BRANCHES = `${API_BASE_URL}/branches`;
export const API_COUNTRIES = `${API_BASE_URL}/countries`;

export const API_CONFIRM_EMAIL = `${API_BASE_URL}/confirm_email`;

export const API_EXPORT_WEBINAR_USERS = `${API_BASE_URL}/export_webinar_users`;
export const API_EXPORT_WEBINAR_USERS_CSV = `${API_BASE_URL}/export_webinar_users_csv`;

// TODO REPLACE WITH ACTION CONSTANT TO SIMPLIFY
export const ERROR_TYPE_USER_CREATE_ERROR = "ERROR_TYPE_USER_CREATE_ERROR";
export const ERROR_TYPE_USER_UPDATE_ERROR = "ERROR_TYPE_USER_UPDATE_ERROR";
export const ERROR_TYPE_LOGIN_ERROR = "ERROR_TYPE_LOGIN_ERROR";
export const ERROR_TYPE_REQUEST = "ERROR_TYPE_REQUEST";

export const API_REGISTER_REQUEST_TO_ADMIN = `${API_BASE_URL}/register_request_to_admin`;

// ADMIN CONSTANTS
export const API_ADMIN_USERS = `${API_BASE_URL}/admin/users`;
export const API_ADMIN_USERS_SPONSORS = `${API_BASE_URL}/admin/user_sponsors`;
export const API_ADMIN_WEBINARS = `${API_BASE_URL}/admin/webinars`;
export const API_ADMIN_DISCIPLINES = `${API_BASE_URL}/admin/disciplines`;
export const EXPORT_USERS_CSV = `${API_BASE_URL}/admin/export_users`;
export const EXPORT_SPONSORS_CSV = `${API_BASE_URL}/admin/export_users/sponsors`;
export const EXPORT_USERS_NEWSLETTER_CSV = `${API_BASE_URL}/admin/export_subscription_sponsors`;
export const EXPORT_WEBINARS_CSV = `${API_BASE_URL}/admin/export_webinars`;
export const API_DASHBOARDS = `${API_BASE_URL}/admin/dashboards_users`;
export const API_DASHBOARDS_WEBINARS = `${API_BASE_URL}/admin/dashboards_webinars`;
export const API_DASHBOARDS_USERS = `${API_BASE_URL}/admin/dashboards/`;

export const API_NOVONORDISK_SUBSCRIBE_USERS = `${API_BASE_URL}/admin/subscribed_users`;
export const API_UNSUBSCRIBE = `${API_BASE_URL}/subscription_sponsors/`;

export const API_ADMIN_SPONSORS = `${API_BASE_URL}/admin/sponsors`;
export const API_SPONSORS = `${API_BASE_URL}/sponsors`;
export const API_DISCIPLINES = `${API_BASE_URL}/disciplines`;

export const API_CONFIRMATION_USERS = `${API_BASE_URL}/admin/confirmation_users`;

export const API_CHECKBOX_NOVONORDISK_USER_SAGA = `${API_BASE_URL}/subscription_sponsors`;

export const API_ADMIN_PARTNERS = `${API_BASE_URL}/admin/partnerships`;
export const API_PARTNERS = `${API_BASE_URL}/partnerships`;

export const API_LANDING_DATA = `${API_BASE_URL}/admin/landings/1`;
export const API_LANDING_DATA_USER = `${API_BASE_URL}/landings/1`;

export const API_ABOUT_DATA = `${API_BASE_URL}/admin/abouts/1`;
export const API_ABOUT_DATA_USER = `${API_BASE_URL}/abouts/1`;
export const API_SEND_APPROVE_USERS = `${API_BASE_URL}/confirmation_users`;

// calendar booking
export const API_CALENDAR_BOOKINGS = `${API_BASE_URL}/bookings`;
export const API_ADMIN_CALENDAR_BOOKINGS = `${API_BASE_URL}/admin/bookings`;
export const API_ADMIN_BANK_HOLIDAYS = `${API_BASE_URL}/admin/bank_holidays`;
export const API_SPONSOR_BOOKINGS = `${API_BASE_URL}/my_bookings`;

export const API_LOAD_QUESTIONS_ON_WEBINAR = `${API_BASE_URL}/admin/user_questions`;
export const API_WEBINAR_CALENDAR_LINKS = `${API_BASE_URL}/event_to_calendars`;

export const API_ADMIN_SUPERHOSTS = `${API_BASE_URL}/admin/superhosts`;

export const API_ZOOM_ACCOUNTS = `${API_BASE_URL}/admin/zoom_accounts`;

export const API_ADMIN_STUDY_GROUPS = `${API_BASE_URL}/admin/groups`;
export const API_ADMIN_STUDY_GROUP_INVITES = `${API_BASE_URL}/admin/group_invites/`;
export const API_ADMIN_STUDY_GROUP_MEMBERS = `${API_BASE_URL}/admin/group_members/`;
export const API_ADMIN_GROUP_MATERIALS = `${API_BASE_URL}/admin/group_materials/`;
export const API_ADMIN_STUDY_GROUP_MATERIALS = `${API_BASE_URL}/admin/group_materials/`;
export const API_LEAVE_GROUP = `${API_BASE_URL}/leave_group/`;

export const API_STUDY_GROUPS = `${API_BASE_URL}/groups`;

export const API_USER_REQUEST_TO_JOIN_GROUP = `${API_BASE_URL}/request_to_group`;

export const API_STUDY_GROUP_MEMBERS = `${API_BASE_URL}/group_members/`;
export const API_STUDY_GROUP_MATERIALS = `${API_BASE_URL}/group_materials/`;
export const API_GROUP_INVITES = `${API_BASE_URL}/group_invites/`;
// export const API_SPONSORS_REPRESENTATIVES = `${API_BASE_URL}/sponsor_representatives/`;
// export const API_SPONSORS_REPRESENTATIVES_REQUESTS = `${API_BASE_URL}/representative_requests/`;
export const API_NOTIFICATIONS = `${API_BASE_URL}/notifications/`;
export const API_NOTIFICATIONS_COUNT = `${API_BASE_URL}/notifications_count/`;

export const API_CLIENT_URLS_ADMIN = `${API_BASE_URL}/admin/client_urls`;
export const API_CLIENT_URL_WEBINARS_ADMIN = `${API_BASE_URL}/admin/client_webinars`;
export const API_CLIENT_WEBINARS = `${API_BASE_URL}/client_webinars`;
export const API_CLIENT_URLS = `${API_BASE_URL}/client_urls`;



// WEBPACK FOOTER //
// ./src/constants/api.js